import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loadingStart, loadingStop } from 'redux/action';
import API from 'services/api';
import Body from './Body';
import { useParams } from 'react-router-dom';

const Index = () => {
  let { subscription_id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [subscriptionDetails, setSubscriptionDetails] = useState(null);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    dispatch(loadingStart());
    await API.fetchSubscriptionDetailsByCustomer(subscription_id)
      .then((response) => {
        if (response) {
          setSubscriptionDetails(response);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  const cancelSubscriptionByCustomer = async () => {
    dispatch(loadingStart());
    await API.cancelSubscriptionByCustomer(subscription_id)
      .then((response) => {
        if (response) {
          toast.success('Subscription Cancelled Successfully!');
        }
        navigate('/');
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };
  return <Body _this={{ subscriptionDetails, cancelSubscriptionByCustomer }} />;
};

export default Index;
